const hasClientId = (value) => value !== null && value !== undefined && value !== "";

const canonicalDateTime = (value) => typeof value === "string"
  ? value.trim().replace("T", " ").slice(0, 19)
  : "";

export const getCheckoutOccurrenceStart = (appointment) => appointment?.repeats === "Yes"
  ? canonicalDateTime(appointment.showstartdate || appointment.start_datetime)
  : "";

export const isLaterRecurringOccurrence = (appointment) => {
  const selected = getCheckoutOccurrenceStart(appointment);
  const first = canonicalDateTime(appointment?.series_start_datetime);
  return Boolean(selected && first && selected !== first);
};

export const getAppointmentPayments = (appointment) => (
  Array.isArray(appointment?.payment) ? appointment.payment : []
);

export const getCheckoutClientId = ({
  appointmentDetail,
  formClientId,
  checkoutClientId,
} = {}) => {
  if (hasClientId(appointmentDetail?.client_id)) return appointmentDetail.client_id;
  if (hasClientId(appointmentDetail?.client?.id)) return appointmentDetail.client.id;
  if (hasClientId(formClientId)) return formClientId;
  return hasClientId(checkoutClientId) ? checkoutClientId : "";
};

export const getAppointmentRefreshRequest = (appointment) => ({
  id: isLaterRecurringOccurrence(appointment) ? null : appointment?.id,
  client_id: getCheckoutClientId({ appointmentDetail: appointment }),
  showdate: appointment?.showdate,
  showstartdate: appointment?.showstartdate,
  showenddate: appointment?.showenddate,
});

const checkoutErrorMessage = (action) => {
  const payload = action?.payload;
  return payload?.message?.error?.message
    || payload?.error?.message
    || payload?.message?.message
    || (typeof payload?.message === "string" ? payload.message : "")
    || action?.error?.message
    || "Unable to complete payment. Please try again.";
};

export const getCheckoutFailureState = (action) => {
  const status = Number(action?.payload?.status);
  return {
    message: checkoutErrorMessage(action),
    retryable: [502, 503, 504].includes(status),
  };
};

export const getCanonicalCheckoutCompletion = (_storeAction, invoiceAction) => (
  invoiceAction?.meta?.requestStatus === "fulfilled"
    && invoiceAction.payload
    && typeof invoiceAction.payload === "object"
    ? invoiceAction.payload
    : null
);
